import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import LocalFireDepartmentRoundedIcon from "@mui/icons-material/LocalFireDepartmentRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";

// The Safety area pages (Admin / Safety Manager) — one place for their
// names, paths and icons, shared by the overview cards, page headers, and
// homepage widget icons. Routes: RouteHandler.js; nav: SideNav.js "safety".
export const SAFETY_PAGES = {
  concerns: {
    name: "Safety Concerns",
    path: "/safety/concerns",
    icon: ReportProblemRoundedIcon,
    tone: "rose",
    tile: "bg-rose-500/15 text-rose-600 dark:text-rose-300",
  },
  extinguishers: {
    name: "Fire Extinguishers",
    path: "/safety/extinguishers",
    icon: LocalFireDepartmentRoundedIcon,
    tone: "orange",
    tile: "bg-orange-500/15 text-orange-600 dark:text-orange-300",
  },
  training: {
    name: "Training Videos",
    path: "/safety/training",
    icon: SchoolRoundedIcon,
    tone: "violet",
    tile: "bg-violet-500/15 text-violet-600 dark:text-violet-300",
  },
  toolbox: {
    name: "Toolbox Talk Results",
    path: "/safety/toolbox-results",
    icon: FactCheckRoundedIcon,
    tone: "sky",
    tile: "bg-sky-500/15 text-sky-600 dark:text-sky-300",
  },
};
